import * as React from 'react';

import styles from './GhostTile.module.scss';

const GhostTile = ({ extended = false }: { extended?: boolean }) => (
  <div className={styles.container} data-testid="ghost-tile">
    <div className={styles.bottom} data-testid="ghost-tile-bottom" />
    {extended && (
      <div className={styles.extended} data-testid="ghost-tile-extended"></div>
    )}
  </div>
);

export default GhostTile;
